
const CollectionService = {  
  
  async fetchCollection(urlApi,userId) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/`);
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || 'Erreur lors de la récupération');
      }
      return await response.json();
    } catch (err) {
      return [];
    }
  },

  async fetchCollectionList(urlApi,userId,collection_id) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/${collection_id}/entite`);
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || 'Erreur lors de la récupération');
      }
      return await response.json();
    } catch (err) {
      return [];
    }
  },
  
  async fetchCollectionShareto(urlApi,userId) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/shareTo`);
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || 'Erreur lors de la récupération');
      }
      return await response.json();
    } catch (err) {
      return [];
    }
  },
  
  async fetchentiteModel(urlApi) {
    try {
      const response = await fetch(`${urlApi}entitemodel`);
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || 'Erreur lors de la récupération');
      }
      return await response.json();
    } catch (err) {
      return [];
    }
  },

  async addEntiteModele(urlApi,modele) {
    try {
      const response = await fetch(`${urlApi}entitemodel`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify( modele )
      });
      const data = await response.json();
      if (response.status === 201) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },

  async updateEntiteModele(urlApi,modeleId,modele) {
    try {
      const response = await fetch(`${urlApi}entitemodel/${modeleId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: JSON.stringify( modele )
      });
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },

  async deleteEntiteModele(urlApi,modeleId) {
    try {
      const response = await fetch(`${urlApi}entitemodel/${modeleId}`, {
        method: 'DELETE',
        headers: {
           'Content-type': 'text/plain'
        }
      });
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },

  async addCollection(urlApi,userId,collectionname) {
    try {
      var newCollection = {"nom_collection": collectionname};
      const response = await fetch(`${urlApi}${userId}/collection`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify( newCollection )
      });      
      const data = await response.json();
      if (response.status === 201) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },

  async updateCollection(urlApi,userId,collection) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/${collection.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: JSON.stringify( collection )
      });      
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },
  
  async deleteCollection(urlApi,userId,collectionid) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/${collectionid}`, {
        method: 'DELETE',
        headers: {
           'Content-type': 'text/plain'
        }
      });      
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },

  async addEntite(urlApi,userId,entite,collection_id) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/${collection_id}/entite`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify( entite )
      });      
      const data = await response.json();
      if (response.status === 201) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },

   /**
   * Ajouter plusieurs entités en une seule requête (batch)
   * @param {string} urlApi - URL de base
   * @param {string} userId - ID utilisateur
   * @param {Array} entites - Tableau d'entités
   * @param {string|number} collection_id - ID collection
   * @returns {Object} Réponse du serveur
   */
   async addEntitesBatch(urlApi, userId, entites, collection_id) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/${collection_id}/entite/batch`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(entites) // le backend doit attendre un tableau d'entites
      });

      const data = await response.json();

      if (response.status === 201 || response.status === 200) {
        return data; // succès
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { success: false, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      console.error(err);
      return { success: false, message: err.message || 'Erreur inconnue' };
    }
  },

  async updateEntite(urlApi,userId,idcollection,entite) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/${idcollection}/entite/${entite.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: JSON.stringify( entite )
      });      
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },
  
  async getEntiteFromCollection(urlApi,userId,entite_id,collection_id) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/${collection_id}/entite/${entite_id}`);
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || 'Erreur lors de la récupération');
      }
      return await response.json();
    } catch (err) {
      return [];
    }
  },
  
  
  async deleteEntityFromCollection(urlApi,userId,collectionid,entiteid) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/${collectionid}/entite/${entiteid}`, {
        method: 'DELETE',
        headers: {
           'Content-type': 'text/plain'
        }
      });      
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },

  async deleteMultiEntityFromCollection(urlApi,userId,collectionid,entiteIds) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/${collectionid}/entite/${entiteIds[0]}`, {
        method: 'POST',
        headers: {
           'Content-type': 'application/json'
        },
        body: JSON.stringify({ ids: entiteIds })
      });      
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },

  async exportSigEntite(urlApi,userId,collection_id) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/${collection_id}/export`, {
        method: 'POST',
      });
      if (!response.ok) {
        return await response.json();
        // throw new Error(errData.message || 'Erreur lors de la récupération');
      }
      return await response.blob();
    } catch (err) {
      return [];
    }
  },

  async getUsersAccount(urlApi,userAccountId) {
    try {
      const response = await fetch(`${urlApi}${userAccountId}/accountinfo`);
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || 'Erreur lors de la récupération');
      }
      return await response.json();
    } catch (err) {
      return [];
    }
  },

  async shareUnshareCollection(urlApi,userAccountId,collection_id, datashare) {
    try {
      const response = await fetch(`${urlApi}${userAccountId}/collection/shareTo/${collection_id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify( datashare )
      });
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },

  async duplicateCollection(urlApi,userId,collectionid) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/${collectionid}/duplicate`, {
        method: 'POST'
      });      
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },

  /**
   * Import de parcelles de l'entrepôt dans une collection (assistant foncier)
   * @param {Object} body - { filter } (CQL2-JSON) ou { idus }
   * @returns {Object} { imported, duplicates, numberMatched } ou { error: true, status, message }
   */
  async importParcelles(urlApi, userId, collection_id, body) {
    try {
      const response = await fetch(`${urlApi}${userId}/collection/${collection_id}/import-parcelles`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });
      const data = await response.json().catch(() => ({}));
      if (response.status === 200) {
        return data;
      }
      return { error: true, status: response.status, message: data.message || 'Erreur lors de l\'import des parcelles' };
    } catch (err) {
      return { error: true, status: 0, message: 'Le serveur des collections ne répond pas' };
    }
  },

  async getEntiteFile(urlApi,userId,entite_id) {
    try {
      const response = await fetch(`${urlApi}${userId}/entite/${entite_id}/fichier`);
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || 'Erreur lors de la récupération');
      }
      return await response.json();
    } catch (err) {
      return [];
    }
  },

  async addFileToEntite(urlApi,userId,entite_id,dataval) {
    try {
      const response = await fetch(`${urlApi}${userId}/entite/${entite_id}/fichier/`, {
        method: 'POST',
        body: dataval
      });      
      const data = await response.json();
      if (response.status === 201) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },

  async deleteFileFromEntite(urlApi,userId,entite_id,sha1) {
    try {
      const response = await fetch(`${urlApi}${userId}/entite/${entite_id}/fichier/${sha1}`, {
        method: 'DELETE',
        headers: {
           'Content-type': 'text/plain'
        }
      });      
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else {
        console.warn(data.message || 'Une erreur est survenue');
        return { error: true, message: data.message || 'Erreur inconnue' };
      }
    } catch (err) {
      return [];
    }
  },

  async getParcelleFromGeojson(data, apiPci) {
    try {
      const response = await fetch(`${apiPci}parcelle/search?skipGeometry=false`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // envoi du corps JSON
      });
  
      // Vérification du statut HTTP
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.message || 'Erreur lors de la requête');
      }
  
      const result = await response.json();
      return result; // succès
    } catch (error) {
      return { error: true, message: error.message }; // erreur
    }
  },
  
  

}

export default CollectionService;